module.exports = __webpack_public_path__ + "static/media/tce.7ad2e27a.png";